import React from "react";

export default function sponsorprops(props) {
  return (
    <>
      <div class="sponsorcard" data-aos="flip-left" data-aos-duration="1000">
        <img src={props.image} alt="SponsorImage" />
      </div>
    </>
  );
}
